import React, { FC } from 'react';
import { Avatar, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { dashboardCompanyOverviewUrl } from 'dashboard409a/common/config/urls';
import { getInitials } from 'utilities';
import { ICompany } from './types';

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  border: `2px solid ${theme.palette.primary.main}`,
  borderRadius: theme.spacing(1.5),
  borderColor: theme.palette.primary.main,
  color: theme.palette.primary.main,
  fontSize: '1rem',
  fontWeight: 700,
  backgroundColor: theme.palette.common?.white || '#ffffff',
}));

const PREFIX = 'Company';

export const companyClasses = {
  avatar: `${PREFIX}-avatar`,
};

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  '& .MuiListItem-root': {
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 0,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      cursor: 'pointer',
    },
  },
  [`& .${companyClasses.avatar}`]: {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: theme.spacing(1.5),
    color: theme.palette.primary.main,
    fontSize: '1rem',
    fontWeight: 'bold',
    backgroundColor: theme.palette.common.white,
  },
}));

const Company: FC<ICompany> = props => {
  const { slug, name } = props;

  return (
    <StyledLink to={dashboardCompanyOverviewUrl(slug)}>
      <ListItem component="button">
        <ListItemIcon>
          <StyledAvatar>{getInitials({ name })}</StyledAvatar>
        </ListItemIcon>
        <ListItemText primary={name} />
      </ListItem>
    </StyledLink>
  );
};

export default Company;
